<template>
  <div class="card">
    <h3 class="card-title">
      {{ post.title }}
    </h3>
    <div class="card-detail">
      <!--      <small>-->
      <!--        <span>{{ this.$qt('post.authorByText') }}</span>-->
      <!--        <span>:</span>-->
      <!--        <strong>{{ post.author }}</strong>-->
      <!--      </small>-->
      <!--      - -->
<!--      <small>-->
<!--        <span>{{ post.date }}</span>-->
<!--      </small>-->
      <!--      - -->
      <!--      <small>-->
      <!--        <span>{{ this.$qt('post.comment.comments') }}</span>-->
      <!--        <span>:</span>-->
      <!--        <strong>{{ post.commentQty }}</strong>-->
      <!--      </small>-->
    </div>
    <img
      v-if="post.thumbnail"
      :src="post.thumbnail"
      :alt="post.title"
      class="card-image"
    >

    <div class="card-note">
      <p>{{ post.summary }}</p>
    </div>
    <router-link :to="{ name: 'post', params: { id: post.id }}">
      <q-link
        :underline="false"
        class="card-read-more"
      >
        <span>{{ this.$qt('post.card.readMore') }}</span>
      </q-link>
    </router-link>
  </div>
</template>

<script>
  export default {
    name: "PostCard",

    props: {
      post: {
        required: true,
        type: Object
      }
    },

    data() {
      return {}
    },

    methods: {}
  }
</script>

<style scoped>
  .card {
    padding: 20px;
    margin-bottom: 20px;
    background: #fff;
    border: 1px solid #cfdbe2;
    border-radius: 5px;
  }

  .card-title {
    text-align: center;
    margin: 0 0 10px 0;
    border-bottom: 1px solid #eaeefb;
    padding-bottom: 15px;
  }

  .card-image {
    border-bottom: 1px solid #eaeefb;
    text-align: center;
    width: 100%;
  }

  .card-detail {
    width: 100%;
    direction: ltr;
  }

  .card-note {
    padding-top: 15px;
  }

  .card-read-more {
    font-size: 14px;
    color: #409eff;
    text-align: center;
    cursor: pointer;
    width: 100%;
    text-decoration: none;
    direction: ltr;
  }

</style>